import React, { useRef } from "react"
import { useReactToPrint } from 'react-to-print'
import { renderAllStars } from "../../utils/hooks/renderstars"
import logo from "../../assets/img/TVA-PPN-logo-fullColor.png"
import footerLogo from "../../assets/img/print-pdf-footer-logo.png"
import locationIcon from "../../assets/img/location_on.png"

export const PrintPdf = ({contractors}) => {
    // print pdf
    const componentRef = useRef()
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    })

    const gtm_tracking = () => {

        // Get all Service Tag Elements
        let facSearchServiceTagElements = document.getElementsByClassName('fac-tag-select-content');

        // Loop through all Service Tag Elements and their text to 'facSearchServiceTags'
        let facSearchServiceTags = ''
        for (let i = 0; i < facSearchServiceTagElements.length; i++) {

            const element = facSearchServiceTagElements[i];

            // Add a comma if its not the first element
            if(i == 0) {
                facSearchServiceTags += element.textContent;
            } else {
                facSearchServiceTags += ", " + element.textContent;
            }

        }

        // Get the search locatoin
        let facSearchLocation = document.querySelector('.fac-input-location-field').value;

        // Add the data to the Datalayer object from Google Tag Manager
        window.dataLayer.push({
            "event": "fac-print-results",
            "fac-services": facSearchServiceTags,
            "fac-project-location": facSearchLocation
        });

    };

    return (
        <div className="print-section">
            <button className="fac-print-btn"
                onClick={() => {
                    handlePrint()
                    gtm_tracking()
                }
            }>
                print
            </button>

            <div className="print-container" ref={componentRef}>
                <div className="print-inner-container">
                    <table className="contractor-print-table">
                        <thead>
                            <tr>
                                <th colSpan="3" style={{paddingBottom: "1rem"}}>
                                    <h1 style={{whiteSpace: "nowrap"}}>We can help you find the right partner.</h1>
                                </th>
                                <th colSpan="1" style={{paddingBottom: "1rem"}}>
                                    <img style={{float: "right"}} src={logo} alt="logo"/>
                                </th>
                            </tr>
                            <tr>
                                <th colSpan="4" style={{paddingBottom: "2rem"}}>
                                    Connect to PPN members who can help you find the best energy solutions for you.
                                    For general questions call us at <a href="tel: (866) 233-0450">(866) 233-0450</a> or email us at
                                    <a href="mailto:TVABusinessincentive@tva.gov"> TVABusinessincentive@tva.gov</a>.
                                </th>
                            </tr>
                            <tr>
                                <th style={{width: "30%"}}>PPN MEMBER<hr /></th>
                                <th style={{width: "25%"}}>SERVICES<hr /></th>
                                <th style={{width: "15%"}} >SRV. AREA<hr /></th>
                                <th style={{width: "30%"}}>CONTACT<hr /></th>
                            </tr>
                        </thead>

                        <tbody>
                            {contractors?.map((contractor) =>
                            <tr key={contractor.Id}>
                                <td>
                                    <div className="print-row">
                                    <br />
                                        <h3>{contractor.company_name}</h3>
                                        <div className="contractor-card-rating">
                                            <div className="hq">
                                                <div><img src={locationIcon} alt="logo"/> {contractor.address1_city}, {contractor.address1_state}</div>
                                            </div>
                                        </div>
                                        <br />
                                    </div>
                                </td>
                                <td className="ppn-services">
                                    <div className="print-row">
                                        {contractor.ta_services_value ? contractor.ta_services_value.replace(/;/g, ", ").slice(0, -2) : ""}
                                    </div>
                                </td>
                                <td className="ppn-srv-area">
                                    <div className="print-row">
                                        {contractor.districts_served_value ? contractor.districts_served_value.replace(/;/g, ", ").slice(0, -2) : ""}
                                    </div>
                                </td>
                                <td className="ppn-contact">
                                    <div className="print-row">
                                      <a href={"tel:+"+contractor.main_phone}>{contractor.main_phone}</a>
                                    </div>
                                </td>
                            </tr>
                            )}
                        </tbody>
                    </table>

                    <div className="export-footer-container">
                        <div className="export-footer">
                            <div className="export-footer-logo">
                                <img src={footerLogo} alt="logo"/>
                            </div>
                            <div className="export-footer-right">
                                <span>(866) 233-0450</span><span>TVABusinessIncentive@tva.gov</span><span>EnergyRight.com</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}